// extracted by mini-css-extract-plugin
export default {"app":"MainPage_app__9EAQe","header":"MainPage_header__KsGeJ","body":"MainPage_body__ng1IT","container":"MainPage_container__2vpv9","footer":"MainPage_footer__jCR-q"};